"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MineRequest = void 0;
var MineRequest = /** @class */ (function () {
    function MineRequest() {
    }
    return MineRequest;
}());
exports.MineRequest = MineRequest;
;
//# sourceMappingURL=mine.request.js.map